import React, {
  Component,
  Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";
import styled from "styled-components";
import users from "../../assets/images/icon_profile/user.svg";
import lock from "../../assets/images/icon_profile/lock.svg";
import key from "../../assets/images/icon_profile/key.svg";
import printer from "../../assets/images/icon_profile/printer.svg";
import book from "../../assets/images/icon_profile/book.svg";
import globe from "../../assets/images/icon_profile/globe.svg";
import logOut from "../../assets/images/icon_profile/log-out.svg";
import * as API from "../../core/service/api.js";
import {} from "../../core/feature/store";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import {
  removeCompany,
  setCompany,
} from "../../core/feature/company/companySlice";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Tabs from "../__template/BottomNavComponent";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Parallax, useParallax } from "react-scroll-parallax";
import User from "../../core/models/user";
import Config from "../../config/Config";
import { Dialog, Transition } from "@headlessui/react";
import { useDispatch } from "react-redux";
import { removeUser } from "../../core/feature/user/userSlice";
import { removeBalance } from "../../core/feature/user/balanceSlice";
import { replace } from "lodash";
import { useTranslation } from "react-i18next";
import { removeToken } from "../../core/feature/token/tokenSlice";
import { removeLastService } from "../../core/feature/lastService/lastServiceSlice";
import { removeCustomApp } from "../../core/feature/company/customAppsSlice";
import { logoutIOS, openUrlInSafari } from "../../config/iosBridge";
import { removeIconApp } from "../../core/feature/company/iconAppSlice";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
const ProfileMobile = () => {
  const gaEventTracker = useAnalyticsEventTracker("LogOut");
  const user: User = useAppSelector((state) => state.user.user);
  let [isOpen, setIsOpen] = useState(false);
  const [appName, setAppName] = useState("")
  const dispact = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(()=>{
    let app = localStorage.getItem("app_version")?.replace("--"," ")
    if(app){
      setAppName(app)
    }
  },[])

  const logout = async () => {
    dispact(removeUser());
    dispact(removeBalance());
    dispact(removeToken());
    dispact(removeIconApp());
    dispact(removeLastService());
    dispact(removeCustomApp());
    localStorage.removeItem("company");
    // localStorage.removeItem("credential");
    localStorage.removeItem("tags");
    localStorage.removeItem("card");
    localStorage.setItem("auto_login", "0");
    gaEventTracker("Click Log Out", "User Logout");

    setIsOpen(false);
    navigate("/login", { replace: true });
    // var element = document.createElement("a") as HTMLElement;
    // element.setAttribute("href", "pspmobile://logout");
    // try {
    //   element.click();
    // } catch (error) {}
    let deviceName = localStorage.getItem("device");
    if (deviceName != null) {
      if (deviceName.includes("android")) {
        // if device is android, call android function
        var element = document.createElement("a") as HTMLElement;
        element.setAttribute("href", "pspmobile://logout");
        try {
          element.click();
        } catch (error) {}
      } else if (deviceName.includes("ios")) {
        // if device is ios, call ios function
        logoutIOS();
      }
    }
  };

  const logoutAction = async () => {
    setIsOpen(true);
  };
  const closeActionLogout = async () => {
    setIsOpen(false);
  };

  const env = Config.BaseUrlDev;
  const getProfileImage = useMemo(() => {
    if (user?.photoUrl == "") {
      return users;
    }
    return env + "main_a/image/get/" + user?.photoUrl + "/pas";
  }, [user]);

  return (
    <>
      <div className="relative min-h-screen h-full bg-psp-primary pb-10">
        <section className="p-10">
          <h1 className="font-medium text-lg text-black font-montserrat mb-4" onClick={() => openUrlInSafari("https://wa.me/6281225951789")}>
            {t("PROFILE.title")}
          </h1>
          <div
            className="flex gap-4 bg-white rounded-xl px-3 py-2.5 items-center"
            onClick={() => navigate("/edit-profile")}
          >
            <img
              src={getProfileImage}
              className="w-14 h-14 rounded-full object-cover bg-psp"
            />
            <div className="flex flex-col gap-0">
              <h1 className="m-0 font-montserrat font-semibold text-lg text-black">
                {user?.name}
              </h1>
              <p className="m-0 font-montserrat text-sm text-gray-400 font-medium">
                {user?.email}
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-4 mt-10">
            <div
              onClick={() => navigate("/edit-profile")}
              className="flex flex-row gap-6 items-center"
            >
              <img src={users} />
              <p className="m-0 font-medium text-sm text-gray-400 font-montserrat no-underline">
                {t("PROFILE.title")}
              </p>
            </div>
            {/* <div
              onClick={() => navigate("/auto-login")}
              className="flex flex-row gap-6 items-center"
            >
              <img src={key} />
              <p className="m-0 font-medium text-sm text-gray-400 font-montserrat no-underline">
                {t("PROFILE.autoLogin")}
              </p>
            </div> */}
            <div
              onClick={() => navigate("/change-password")}
              className="flex flex-row gap-6 items-center"
            >
              <img src={lock} />
              <p className="m-0 font-medium text-sm text-gray-400 font-montserrat no-underline">
                {t("PROFILE.changePassword")}
              </p>
            </div>

            <div
              onClick={() => navigate("/faq")}
              className="flex flex-row gap-6 items-center"
            >
              <img src={book} />
              <p className="m-0 font-medium text-sm text-gray-400 font-montserrat no-underline">
                {t("PROFILE.faq")}
              </p>
            </div>
            <div
              onClick={() => navigate("/change-language")}
              className="flex flex-row gap-6 items-center"
            >
              <img src={globe} />
              <p className="m-0 font-medium text-sm text-gray-400 font-montserrat no-underline">
                {t("PROFILE.language")}
              </p>
            </div>
            <div
              onClick={() => logoutAction()}
              className="flex flex-row gap-6 items-center"
            >
              <img src={logOut} />
              <p className="m-0 font-medium text-sm text-gray-400 font-montserrat no-underline">
                {t("PROFILE.logout")}
              </p>
            </div>
            {
              appName && (
                <div className=" text-gray-400 py-3 text-center">{appName}</div>
              )
            }
          </div>
        </section>
        <Tabs tab={`${t("NAVBAR.profile")}`}></Tabs>

        <Transition appear show={isOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-10"
            onClose={closeActionLogout}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      {t("PROFILE.confirm")}
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        {t("PROFILE.toLogout")}
                      </p>
                    </div>

                    <div className="mt-4 flex gap-2">
                      <button
                        type="button"
                        className="active:bg-psp-hover active:text-white inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                        onClick={() => logout()}
                      >
                        {t("OTHER.yes")}
                      </button>
                      <button
                        type="button"
                        className="active:bg-zinc-100 inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                        onClick={() => closeActionLogout()}
                      >
                        {t("OTHER.no")}
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      </div>
    </>
  );
};

export default ProfileMobile;
